import ShipLaborWork from '@/models/ShipLaborWork'
import ShipSailor from '@/models/ShipSailor'
import ShipLaborTallyFetch from '../laborTally/fetch'
import dayjs from 'dayjs'

export default class LaborSailor {
    static of(shipId, isAll = true) {
        // return Promise.resolve()
        //     .then(() => {
        //         return ShipLaborWork.api().fetch(shipId)
        //     })
        //     .then(() => {
        //         return ShipSailor.api().list(shipId, isAll)
        //     })
        return Promise.all([
                ShipLaborWork.api().fetch(shipId),
                ShipSailor.api().list(shipId, isAll)
            ])
            // .then(() => {
            //     const yearMonth = dayjs().format('YYYY-MM')
            //     return ShipLaborTallyFetch.of(shipId, '', { yearMonth })
            // })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
